import { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
const SocketContext = createContext();
export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  useEffect(() => {
    const s = io('http://localhost:5000');
    setSocket(s);
    return () => s.close();
  }, []);
  return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
};
export const useSocket = () => useContext(SocketContext);